import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import _IconEye from "@arco-design/web-react/icon/react-icon/IconEye";
import "@arco-design/web-react/es/Popover/style";
import _Popover from "@arco-design/web-react/es/Popover";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import "@arco-design/web-react/es/Image/style";
import _Image from "@arco-design/web-react/es/Image";
import "@arco-design/web-react/es/Breadcrumb/style";
import _Breadcrumb from "@arco-design/web-react/es/Breadcrumb";
import "@arco-design/web-react/es/Tabs/style";
import _Tabs from "@arco-design/web-react/es/Tabs";
import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles/index.module.less';
import data from './data';
import { useHistory } from 'react-router-dom';
const TabPane = _Tabs.TabPane;
const BreadcrumbItem = _Breadcrumb.Item;

function Index() {
  const initData = [{
    name: '汽车制造数据',
    decs: '汽车制造数据用于优化生产流程，提高产品质量和效率，帮助制造商进行市场需求预测，指导产品设计和改进。',
    value: '汽车制造数据',
    active: false,
    theme: '车辆/车辆制造数据/车辆研发优化',
    readCount: 1819
  }, {
    name: '企业画像数据',
    value: '企业画像数据',
    decs: '企业画像数据帮助企业更精准地了解自身市场定位和竞争状况，从而制定有效的商业策略和市场推广计划。这些数据也为投资者和合作伙伴提供了评估企业实力和潜力的依据。',
    active: false,
    theme: '企业画像数据/潜客挖掘数据/精准营销数据',
    readCount: 2652
  }, {
    name: '互联网数据',
    value: '互联网数据',
    decs: '用于分析用户行为、优化产品服务，为企业提供市场动态和用户需求的洞察。这些数据也助于政府和社会机构监测网络舆情、制定相关政策。',
    active: false,
    theme: '舆情分析数据/用户行为数据/用户需求洞察',
    readCount: 2733
  }, {
    name: '金融风控',
    decs: '金融风控数据主要用于评估借款人或企业的信用风险，以便金融机构能够有效管理贷款和投资组合，降低潜在的损失。同时，这些数据帮助金融机构制定合理的信贷政策，保障金融市场的稳定运行。',
    value: '金融风控',
    active: false,
    theme: '金融数据/金融风控/风险画像',
    readCount: 1315
  }, {
    name: 'OTA数据',
    decs: '	用于分析和优化旅游产品销售，帮助旅游企业了解市场趋势、调整价格策略和提升服务质量。同时，这些数据也为消费者提供了比较和选择旅游产品的信息，从而做出更合适的预订决策。',
    value: 'OTA数据',
    active: false,
    theme: '游客画像/客流分析/个性化服务',
    readCount: 690
  }, {
    name: '房地产数据',
    decs: '用于评估市场趋势、确定房产价值，帮助投资者和开发商做出明智的投资决策。同时，这些数据也为购房者提供了房价走势、地段信息等，以便他们做出合理的购房选择。',
    value: '房地产数据',
    active: false,
    theme: '房地产交易数据/房价走势/房产投资决策',
    readCount: 892
  }];
  const history = useHistory();
  const [visible, setVisble] = useState(false);
  const param = new URLSearchParams(location.search);
  const value = param.get('value');
  const [tableData, setTableData] = useState();
  const currentData = useMemo(() => {
    if (value) {
      return initData.find(it => it.value === value);
    }
  }, [value]);
  const currentIndex = useMemo(() => {
    if (value) {
      switch (value) {
        case '汽车制造数据':
          return 1;

        case '企业画像数据':
          return 2;

        case '互联网数据':
          return 3;

        case '金融风控':
          return 4;

        case 'OTA数据':
          return 5;

        case '房地产数据':
          return 6;
      }
    }
  }, [value]);
  useEffect(() => {
    if (value) {
      setTableData(data[value]);
    }
  }, [value]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  function colGenerator({
    title,
    dataIndex,
    ellipsis = true,
    align = 'center',
    width,
    ...args
  }) {
    return {
      title,
      dataIndex,
      ellipsis,
      align,
      width,
      ...args
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, "\u82B3\u79BE\u884C\u4E1A\u6570\u636E\u8D44\u4EA7\u8BE6\u60C5"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 62,
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(_Breadcrumb, null, /*#__PURE__*/React.createElement(BreadcrumbItem, {
    style: {
      color: '#165dff'
    },
    href: "/"
  }, "\u6570\u636E\u8D44\u4EA7\u76EE\u5F55"), /*#__PURE__*/React.createElement(BreadcrumbItem, null, "\u6570\u636E\u96C6"))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRowOne
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.detailRowOneLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftContent
  }, /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    src: require(`./img/img${currentIndex}.png`),
    width: 212,
    height: 160
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rightContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rightContentOne
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rightContentOneText
  }, value), /*#__PURE__*/React.createElement(_Tag, {
    color: "arcoblue"
  }, "\u6570\u636E\u6307\u6807")), /*#__PURE__*/React.createElement("div", {
    className: styles.rightContentTwo
  }, currentData.decs), /*#__PURE__*/React.createElement("div", {
    className: styles.rightContentThree
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#7b89a0'
    }
  }, "\u6570\u636E\u4E3B\u9898\uFF1A"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#42536e'
    }
  }, currentData.theme)), /*#__PURE__*/React.createElement("div", {
    className: styles.rightContentFour
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#7b89a0'
    }
  }, "\u4EF7\u683C\uFF1A"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#f42e2e',
      fontSize: 20
    }
  }, "\u9762\u8BAE")), /*#__PURE__*/React.createElement("div", {
    className: styles.rightContentFive
  }, /*#__PURE__*/React.createElement(_Popover, {
    position: "top",
    content: /*#__PURE__*/React.createElement("div", {
      style: {
        width: 332,
        margin: '0 auto'
      }
    }, /*#__PURE__*/React.createElement(_Image, {
      width: 332,
      height: 347,
      src: require('./img/qrcode.png')
    }))
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary"
  }, "\u7ACB\u5373\u54A8\u8BE2"))), /*#__PURE__*/React.createElement("div", {
    className: styles.readCount
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconEye, {
    style: {
      fontSize: 16
    }
  }), "\u6D4F\u89C8\u91CF\uFF1A", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#165dff'
    }
  }, currentData.readCount))))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRowOneRight
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.detailRowOneRightOne
  }, "\u6570\u636E\u4F9B\u5E94\u5546\uFF1A", /*#__PURE__*/React.createElement("span", null, "\u5E7F\u5DDE\u82B3\u79BE\u6570\u636E\u6709\u9650\u516C\u53F8")), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRowOneRightTwo
  }, "\u5E7F\u5DDE\u82B3\u79BE\u6570\u636E\u6709\u9650\u516C\u53F8\u6210\u7ACB\u4E8E2014\u5E74\uFF0C\u662F\u56FD\u5185\u9886\u5148\u7684\u57FA\u4E8E\u9690\u79C1\u8BA1\u7B97\u7684\u6570\u636E\u5B89\u5168\u6D41\u901A\u670D\u52A1\u5546\uFF0C\u56FD\u5BB6\u9AD8\u65B0\u6280\u672F\u4F01\u4E1A\uFF0C\u5E7F\u4E1C\u7701\u4E13\u7CBE\u7279\u65B0\u4F01\u4E1A\uFF0C\u5E7F\u5DDE\u5E02\u672A\u6765\u72EC\u89D2\u517D\u4F01\u4E1A\uFF0C\u9996\u6279\u5E7F\u4E1C\u7701\u6570\u636E\u7ECF\u7EAA\u4EBA\uFF0C\u5E7F\u4E1C\u7701\u79D1\u6280\u5385\u7CA4\u6E2F\u6570\u636E\u5B89\u5168\u4E0E\u9690\u79C1\u4FDD\u62A4\u7701\u7EA7\u91CD\u70B9\u5B9E\u9A8C\u5BA4\u5171\u5EFA\u5355\u4F4D\u3002\u8363\u83B72023\u5E74\u5EA6\u5E7F\u4E1C\u7701\u79D1\u5B66\u6280\u672F\u5956\u79D1\u6280\u8FDB\u6B65\u5956\u4E00\u7B49\u5956\u3002\u81EA\u4E3B\u7814\u53D1\u7684\u6570\u636E\u8981\u7D20\u53EF\u4FE1\u6D41\u901A\u57FA\u7840\u8BBE\u65BD--\u98DE\u6570\u5E73\u53F0\uFF0C\u4E13\u6CE8\u63D0\u4F9B\u6570\u636E\u8D44\u4EA7\u7BA1\u7406\u670D\u52A1\u3001\u6570\u636E\u5B89\u5168\u670D\u52A1\u3001\u6570\u636E\u6D41\u901A\u670D\u52A1\u3001\u4EE5\u53CA\u884C\u4E1A\u6570\u636E\u5E94\u7528\u89E3\u51B3\u65B9\u6848\uFF0C\u4E3A\u5BA2\u6237\u5B9E\u73B0\u6570\u636E\u8D44\u6E90\u786E\u6743\u5165\u8868\u3001\u6570\u636E\u5B89\u5168\u6D41\u901A\u4E0E\u4EF7\u503C\u521B\u9020\u3002\u82B3\u79BE\u6570\u636E\u81F4\u529B\u4E8E\u6784\u5EFA\u4E92\u901A\u4E92\u4FE1\u7684\u6570\u636E\u4E16\u754C\uFF0C\u4E3A\u4E2D\u56FD\u6570\u5B57\u7ECF\u6D4E\u9AD8\u8D28\u91CF\u53D1\u5C55\u8D21\u732E\u529B\u91CF\u3002"))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRowTwo
  }, /*#__PURE__*/React.createElement(_Tabs, {
    defaultActiveTab: "1"
  }, /*#__PURE__*/React.createElement(TabPane, {
    key: "1",
    title: "\u6307\u6807\u4FE1\u606F",
    style: {
      padding: 20
    }
  }, /*#__PURE__*/React.createElement(_Table, {
    data: tableData,
    columns: [colGenerator({
      title: '序号',
      width: 80,
      dataIndex: 'index'
    }), colGenerator({
      title: '指标名',
      dataIndex: 'name'
    }), colGenerator({
      title: '指标中文名',
      dataIndex: 'chineseName'
    }), colGenerator({
      title: '指标口径',
      dataIndex: 'metric'
    }), colGenerator({
      title: '更新频率',
      dataIndex: 'frequency'
    }), colGenerator({
      title: '覆盖范围',
      dataIndex: 'range'
    })],
    pagination: {
      showTotal: true,
      sizeCanChange: true
    }
  }))))), /*#__PURE__*/React.createElement(_Modal, {
    visible: visible,
    title: "\u54A8\u8BE2\u6211\u4EEC",
    footer: null,
    onCancel: () => {
      setVisble(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 332,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement(_Image, {
    width: 332,
    height: 347,
    src: require('./img/qrcode.png')
  }))));
}

export default Index;